import { render } from "./Fabrics.vue?vue&type=template&id=4cb3c2cc"
import script from "./Fabrics.vue?vue&type=script&lang=js"
export * from "./Fabrics.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__